import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {isBadgeAction, isJourneyActionCompleted} from '@/services/loyalty/loyaltyUtils';
import {selectNotCompletedActions} from '@/state/selectors/consumerLoyalty';

export const useFirstNotCompletedAction = (journey?: any) => {
    const notCompletedAction = useSelector(selectNotCompletedActions)[0];

    return useMemo(() => {
        if (!journey) {
            return notCompletedAction;
        }

        for (const level of journey?.journeyLevels || []) {
            const levelActions = level.journeyActions?.filter((o: any) => !isBadgeAction(o));
            const action = levelActions?.find((o: any) => !isJourneyActionCompleted(o));

            if (action) {
                return {...action, journeyBadge: level.journeyBadge, levelActions};
            }
        }

        return undefined;
    }, [journey, notCompletedAction]);
};
